import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Spinner,
} from 'reactstrap';

import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

//redux
import TableContainer from '../../../Components/Common/TableContainer';
import { withTranslation } from 'react-i18next';
import { Can } from '../../../helpers/casl';
import Search from '../../../Components/Common/Search';
import RangeDatePicker from '../../../Components/Common/RangeDatePicker';
import moment from 'moment';
import useQsParams from '../../../Components/Hooks/QueryString';
import EmptyList from '../../../Components/Common/EmptyList';

const TableAuditManagement = ({
  props,
  columns,
  isLoading,
  audits,
  meta,
  page,
  auditAction,
  setPage,
}) => {
  const { qs, setSearchParams, setSearchParamsAsObject } =
    useQsParams();
  const [createdAt, setCreatedAt] = useState([]);
  const animatedComponents = makeAnimated();

  const multiSelectStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '320px',
      width: 'auto',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#1a2a3e',
      fontSize: '14px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#cccccc',
      svg: {
        width: '20px',
        height: '20px',
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      width: '18px',
      transition: '.2s ease-in',
      ':hover': {
        color: '#999999',
      },
    }),
  };

  const _parseCreatedAt = () => {
    const hasCreatedAt = qs.get('createdAt');
    let dateRange = [];

    if (hasCreatedAt) {
      const from = hasCreatedAt?.split(',')?.[0];
      const to = hasCreatedAt?.split(',')?.[1];

      dateRange = [
        moment.unix(from).format('D/M/YY'),
        moment.unix(to || from).format('D/M/YY'),
      ];
    }

    setCreatedAt(dateRange);
  };

  useEffect(() => {
    _parseCreatedAt();
  }, [qs.get('createdAt')]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={props.t('audit-management.heading')} pageTitle={props.t('audit-management.extra')} />
        <Row>
          <Col lg={12}>
            <Card id="leadsList">
              <CardHeader className="border-0">
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-12 g-2 g-lg-3">
                  <Col xl={2}>
                    <Search
                      placeholder={props.t('audit-management.table.email')}
                      value={qs?.get('email')?.replace(/%/g, '')}
                      onSubmit={({ id }) => {
                        const value = _.trim(id);
                        setSearchParamsAsObject({
                          email: id ? `%${value}%` : '',
                          page: 1,
                        });
                      }}
                    />
                  </Col>

                  <Col xl={2}>
                    <RangeDatePicker
                      onClear={() => setSearchParams('createdAt', '')}
                      placeholder={props.t('audit-management.table.created_at')}
                      value={createdAt}
                      onChange={(v) => {
                        if (v[0] && v[1]) {
                          const d1 = moment(v[0]).unix();
                          const d2 = moment(v[1]).unix();
                          const value = !d2 ? d1 : `${d1},${d2}`;
                          setSearchParams('createdAt', value);
                        }
                      }}
                    />
                  </Col>

                  <Col xl={'auto'}>
                    <Select
                      name="action"
                      id="action"
                      isClearable={qs.get('action')?.split(',').length > 1}
                      isSearchable
                      components={animatedComponents}
                      isMulti={true}
                      placeholder={props.t('audit-management.table.action')}
                      onChange={(selectedOptions) => {
                        const values = selectedOptions
                          ?.map((option) => option.value)
                          .join(',');
                        setSearchParamsAsObject({
                          action: values,
                          page: 1,
                        });
                      }}
                      value={auditAction.filter((x) => {
                        const actionInUrl = qs.get('action')?.split(',');
                        return actionInUrl?.includes(x.value);
                      })}
                      options={auditAction}
                      styles={multiSelectStyles}
                    />
                  </Col>

                  {isLoading ? (
                    <Col xl="auto">
                      <Spinner color="secondary" className="m-0" />
                    </Col>
                  ) : null}
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Can I="read" a="sales_management">
                  <div>
                    {!audits?.length && qs.toString() ? (
                      <div className="mt-3">
                        <EmptyList
                          heading={props.t('search-empty-heading')}
                          body={props.t('table-content-empty-results')}
                        />
                      </div>
                    ) : (
                      <TableContainer
                        isLoading={isLoading}
                        columns={columns}
                        data={audits || []}
                        activePage={page}
                        pageSize={meta?.take || 10}
                        totalPages={meta?.pages || 0}
                        count={meta?.total || 0}
                        setPage={setPage}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                      />
                    )}
                  </div>
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation()(TableAuditManagement);
